<template>
  <div id="app">
    <div v-if="hackReset == true">
      <sub-header @clearPfrom="clearfromdata" v-if="!$route.meta.fullPage"></sub-header>
    </div>
    <template v-if="hackReset == true && isRouterAlive">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view/>
      </keep-alive>
      <router-view v-else-if="$route.meta.noKeepAlive" :key="$route.fullPath"/>
      <router-view v-else/>
    </template>
    <sub-footer v-if="!$route.meta.fullPage"></sub-footer>
    <!-- 注册弹框 -->
    <el-dialog
      title="用户注册"
      width="380px"
      :visible.sync="dialogSignIn"
      class="head_dialog"
      :before-close="closeDialogSignIn"
      center
    >
      <el-form :model="SignInForm">
        <el-input
          style="margin-bottom: 28px;"
          placeholder="请输入手机号码"
          v-model="SignInForm.phone"
        ></el-input>
        <el-form-item
          label=""
          prop="code"
          class="pr"
          style="margin-bottom: 28px;"
        >
          <el-input
            prop="code"
            v-model="SignInForm.code"
            placeholder="验证码"
          ></el-input>
          <div @click="getCode('register')" class="code-btn" :disabled="!show">
            <span v-show="show">发送验证码</span>
            <span v-show="!show" class="count">{{ count }} s</span>
          </div>
        </el-form-item>
        <el-input
          placeholder="请设置密码"
          v-model="SignInForm.password"
          show-password
        ></el-input>
        <div class="aialog_txt">
          已有账号去
          <span style="color:#00C590;" @click="toggleDialogLogin">登录</span>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="signInSubmit">注册</el-button>
      </div>
    </el-dialog>
    <!-- 注册弹框结束 -->

    <!-- 登录弹框 -->
    <el-dialog
      title="用户登录"
      width="380px"
      :visible.sync="dialogLogin"
      class="head_dialog"
      :before-close="closeDialogLogin"
      center
    >
      <el-form :model="SignInForm">
        <el-tabs
          class="head_dialog_tabs"
          v-model="activeName"
          @tab-click="handleClick"
          id="logintabs"
        >
          <el-tab-pane label="密码登录" name="pwdLogin">
            <el-input
              style="margin-bottom: 30px;"
              placeholder="请输入手机号码"
              v-model="SignInForm.phone"
            ></el-input>
            <el-input
              placeholder="请输入密码"
              v-model="SignInForm.password"
              show-password
            ></el-input>
          </el-tab-pane>
          <el-tab-pane label="验证登录" name="codeLogin">
            <el-input
              style="margin-bottom: 28px;"
              placeholder="请输入手机号码"
              v-model="SignInForm.phone"
            ></el-input>
            <el-form-item
              label=""
              prop="code"
              class="pr"
              style="margin-bottom: 0px;"
            >
              <el-input
                prop="code"
                v-model="SignInForm.code"
                placeholder="验证码"
              ></el-input>
              <div @click="getCode('login')" class="code-btn" :disabled="!show">
                <span v-show="show">发送验证码</span>
                <span v-show="!show" class="count">{{ count }} s</span>
              </div>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
        <div class="aialog_btn_box">
         <!-- <div class="wx_login_box" @click="openWxCode">
             <img class="wx_login_icon" src="./assets/wx_login.png" />
             <span class="wx_login_txt">微信</span>
          </div> -->
          <div class="aialog_register_box">
            <span @click="toggleChangepwd">忘记密码</span>
            <span class="txt_line"></span>
            <span style="color:#00C590;" @click="toggleDialogSignIn">注册账号</span>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="loginSubmit">登录</el-button>
      </div>
    </el-dialog>
    <!-- 登录弹框结束 -->

    <!-- 修改密码弹框 -->
    <el-dialog
      title="忘记密码"
      width="380px"
      :visible.sync="dialogChangePwd"
      class="head_dialog"
      :before-close="closeChangePwd"
      center
    >
      <el-form :model="SignInForm">
        <el-input
          style="margin-bottom: 28px;"
          placeholder="请输入手机号码"
          v-model="SignInForm.phone"
        ></el-input>
        <el-form-item
          label=""
          prop="code"
          class="pr"
          style="margin-bottom: 28px;"
        >
          <el-input
            prop="code"
            v-model="SignInForm.code"
            placeholder="验证码"
          ></el-input>
          <div @click="getCode" class="code-btn" :disabled="!show">
            <span v-show="show">发送验证码</span>
            <span v-show="!show" class="count">{{ count }} s</span>
          </div>
        </el-form-item>
        <el-input
          placeholder="请设置新密码"
          v-model="SignInForm.password"
          show-password
        ></el-input>
        <el-input
          style="margin-top: 28px;"
          placeholder="重复新密码"
          v-model="SignInForm.againpwd"
          show-password
        ></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changePwdSubmit">重置密码</el-button>
      </div>
    </el-dialog>
    <!-- 修改结束 -->

    <!-- wx登录二维码 -->
    <el-dialog title=""
      class="code_dialog"
      width="100%"
      fullscreen
      :visible.sync="dialogChangeCode"
      :before-close="closeDialogCode"
    >
      <div class="wx_code_wrap_box">
        <div class="wx_code_head_box">
          <div class="wx_code_head_title">
            <img class="wx_code_head_icon" src="./assets/wx_login.png" />
            <span>扫码关注公众号登录</span>
          </div>
          <div class="">蜗考题库</div>
        </div>
        <div class="wx_code_box">
          <img class="wx_code_img" v-if="wxCodeData" :src="wxCodeData.url" />
          <div class="wx_code_msk cursor" v-if="checkCode&&checkCode.status==-1" @click="refWxCode">
            <div class="wx_code_msk_title">二维码已过期</div>
            <div class="">点击刷新</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- wx登录二维码 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "./store";
import SubHeader from "@/components/SubHeader";
import SubFooter from "@/components/SubFooter";

const TIME_COUNT = 60; // 倒计时的时间
export default {
  name: "App",
  components: {
    SubHeader,
    SubFooter
  },
  provide() {
    return {
      reload: this.reload,
      hack: this.hackResets
    };
  },
  data() {
    return {
      hackReset: true,
      timer: null,
      SignInForm: {
        phone: "",
        verify: "",
        password: "",
        againpwd: "",
        code: ""
      },
      activeName: "pwdLogin",
      show: true,
      count: "",
      isRouterAlive: true,
      dialogChangeCode: false,
      wxCodeData: null,
      timer: null,
      checkCode: null,
      isTap: true
    };
  },
  computed: {
    ...mapState(["dialogSignIn", "dialogLogin", "dialogChangePwd"])
  },
  mounted() {
    document.onkeydown = (e) => {
      if(e.keyCode === 13 && this.$store.state.dialogLogin === true){
        this.loginSubmit();
      }
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    handleClick(tab, event) {
      // console.log(tab,1,event)
    },
    openWxCode() {
      clearInterval(this.timer)
      this.timer=null
      this.checkCode=null
      this.wxCodeData=null
      this.getWxCode()
    },
    //获取微信登录二维码
    getWxCode(isTogle) {
      this.$http.get("/api/v2/auth/wxOfficialPcLoginQrcode").then(res=>{
        if(res.data.code==1){
          console.log(res,"---7777---")
          this.wxCodeData=res.data.data
          if(isTogle){
            this.checkCode=null
          }else{
            this.dialogChangeCode=true
          }

          this.timer=setInterval(()=>{
            this.checkcheckWxOfficial()
          },2000)
        }else if(res.data.code === 0){
          this.$message.error(res.data.msg);
        }

        if(isTogle){
          this.isTap=true
        }
      })
    },
    //检查二维码失效
    checkcheckWxOfficial(){
      this.$http.get("/api/v2/auth/checkWxOfficialPcLoginQrcode",{params:{scene_str:this.wxCodeData.scene_str}}).then(res=>{
        if(res.data.code==1){
          this.checkCode=res.data.data
          if(res.data.data.status==-1){
            clearInterval(this.timer)
            this.timer=null
          }else if(res.data.data.status==10){
            clearInterval(this.timer)
            this.timer=null
            localStorage.setItem("token", res.data.data.infos.token);
            this.$store.commit("setToken",res.data.data.infos.token);
            this.$message({
              message: res.data.msg,
              type: "success",
              showClose: true
            });
            store.commit("setDialogLogin", false);
            this.dialogChangeCode=false
            this.hackResets();
          }
        }
      })
    },
    //刷新二维码
    refWxCode() {
      if(this.isTap){
        this.isTap=false
        clearInterval(this.timer)
        this.timer=null
        this.getWxCode(true)
      }

    },
    getSendCode(tel, type) {
      //获取验证码
      this.$http
        .post("/api/v2/Vcode/sendCode", {
          tel: tel,
          type: type
        })
        .then(res => {
          if (res.data.code === 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
          } else if (res.data.code === 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {});
    },
    loginAPI(name, pwd, type) {
      //请求登录
      var data = {
        device_type: "pc",
        username: name
      };
      if (type === "pwd") {
        data.password = pwd;
      } else {
        data.code = pwd;
      }
      this.$http
        .post("/api/v2/auth/login", data, {
          headers: {
            "Device-Type": "pc"
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            localStorage.setItem("token", res.data.data.token);
            this.$store.commit("setToken", res.data.data.token);
            this.$message({
              message: res.data.msg,
              type: "success",
              showClose: true
            });
            store.commit("setDialogLogin", false);
            this.hackResets();
          } else if (res.data.code === 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    getCode(type) {
      if (!/^1[0123456789]\d{9}$/.test(this.SignInForm.phone)) {
        //验证手机号
        this.$message.error("手机号码格式有误");
        return false;
      }

      // 验证码倒计时
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.getSendCode(this.SignInForm.phone, type); //获取验证码
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    toggleDialogLogin() {
      this.SignInForm = {};
      store.commit("setDialogLogin", true);
      store.commit("setDialogSignIn", false);
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
    },
    toggleDialogSignIn() {
      this.SignInForm = {};
      store.commit("setDialogSignIn", true);
      store.commit("setDialogLogin", false);
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
    },
    toggleChangepwd() {
      this.SignInForm = {};
      store.commit("setChangePwd", true);
      store.commit("setDialogLogin", false);
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
    },
    closeDialogSignIn(done) {
      //关闭窗口前弹窗事件
      done(false);
      store.commit("setDialogSignIn", false);
      this.SignInForm = {};
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
    },
    closeDialogLogin(done) {
      //关闭窗口前弹窗事件
      done(false);
      store.commit("setDialogLogin", false);
      this.SignInForm = {};
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
    },
    closeChangePwd(done) {
      done(false);
      store.commit("setChangePwd", false);
      this.SignInForm = {};
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
    },
    //微信二维码登录关闭监听
    closeDialogCode(done) {
      clearInterval(this.timer)
      this.timer=null
      this.dialogChangeCode=false
      done(false);
      this.checkCode=null
    },
    loginSubmit() {
      //登录提交
      if (this.activeName === "codeLogin") {
        if (this.phoneVerify() === false) {
          return false;
        } else if (this.codeVerify() === false) {
          return false;
        }
        this.loginAPI(this.SignInForm.phone, this.SignInForm.code);
      } else if (this.activeName === "pwdLogin") {
        if (this.phoneVerify() === false) {
          return false;
        } else if (this.pwdVerify(this.SignInForm.password) === false) {
          return false;
        }
        this.loginAPI(this.SignInForm.phone, this.SignInForm.password, "pwd");
      }
    },
    signInSubmit() {
      //注册提交
      if (this.phoneVerify() === false) {
        return false;
      } else if (this.codeVerify() === false) {
        return false;
      } else if (this.pwdVerify(this.SignInForm.password) === false) {
        return false;
      }

      this.$http
        .post("/api/v2/Register/doRegister", {
          tel: this.SignInForm.phone,
          code: this.SignInForm.code,
          password: this.SignInForm.password,
          source: 3
        })
        .then(res => {
          if (res.data.code === 1) {
            localStorage.setItem("token", res.data.data.token);
            this.$store.commit("setToken",res.data.data.token);
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            store.commit("setDialogSignIn", false);
            this.hackResets();
          } else if (res.data.code === 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    changePwdSubmit() {
      //找回密码
      if (this.phoneVerify() === false) {
        return false;
      } else if (this.codeVerify() === false) {
        return false;
      } else if (this.pwdVerify(this.SignInForm.password) === false) {
        return false;
      } else if (this.pwdVerify(this.SignInForm.againpwd, true) === false) {
        return false;
      }
      this.$http
        .post("/api/v2/register/findPassword", {
          mobile: this.SignInForm.phone,
          code: this.SignInForm.code,
          password: this.SignInForm.password,
          password_re: this.SignInForm.againpwd
        })
        .then(res => {
          if (res.data.code === 1) {
            //   localStorage.removeItem('token');
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            store.commit("setChangePwd", false);
            //   this.hackResets()
          } else if (res.data.code === 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    codeVerify() {
      //验证码验证
      if (!/^\d{6}$/.test(this.SignInForm.code)) {
        this.$message.error("请输入正确验证码");
        return false;
      }
    },
    phoneVerify() {
      //手机号码验证
      if (!/^1[0123456789]\d{9}$/.test(this.SignInForm.phone)) {
        this.$message.error("手机号码格式有误");
        return false;
      }
    },
    pwdVerify(pwd, re) {
      //密码验证
      if (/^\d+$/.test(pwd)) {
        re
          ? this.$message.error("重复密码不能为纯数字")
          : this.$message.error("密码不能为纯数字");
        return false;
      } else if (/^[a-zA-Z]+$/.test(pwd)) {
        re
          ? this.$message.error("重复密码不能为空且不能为纯字母")
          : this.$message.error("密码不能为空且不能为纯字母");
        return false;
      } else if (pwd.length < 6) {
        re
          ? this.$message.error("重复密码不能少于6位")
          : this.$message.error("密码不能少于6位");
        return false;
      } else if (/^[_#@]+$/.test(pwd)) {
        re
          ? this.$message.error("重复密码不能为纯符号")
          : this.$message.error("密码不能为纯符号");
        return false;
      }
    },
    hackResets() {
      //刷新页面
      this.hackReset = false;
      this.$nextTick(() => {
        this.hackReset = true;
      });
    },
    clearfromdata(d) {
      this.SignInForm = d;
    }
  }
};
</script>

<style>
.head_dialog input:-internal-autofill-selected {
  background-color: #ffffff !important;
}
.head_dialog .el-dialog__title {
  font-size: 24px;
}
.head_dialog_tabs > .el-tabs__header {
  margin-bottom: 40px;
}
.wx_code_wrap_box{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wx_code_head_box{
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  text-align: center;
}
.wx_code_wrap_box .wx_code_head_icon{
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.wx_code_wrap_box .wx_code_head_title{
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue